import http from '@/assets/common/http';
// 拉取全部原材料
export function productionSettingFun(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 1,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 删除原材料
export function deleteFun(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 2,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 新增原材料
export function addProductionFun(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 6,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取产品
export function queryProductFun(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 7,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取生产配置详情
export function productionDetailFun(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 3,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 添加生产详情
export function addDetailFun(data) {
  const params = {
    SERVICE_ID: '10003',
    OTYPE: 5,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 修改别名
export function editFun(data) {
  const params = {
    SERVICE_ID: '10053',
    OTYPE: 8,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 批量导入生产配置
export function exportProductionFun(data) {
  const params = {
    SERVICE_ID: '10053',
    OTYPE: 15,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
export function productionSettingFun1(data) {
  const params = {
    SERVICE_ID: '12003',
    OTYPE: 1,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 删除原材料
export function deleteFun1(data) {
  const params = {
    SERVICE_ID: '12003',
    OTYPE: 2,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 新增原材料
export function addProductionFun1(data) {
  const params = {
    SERVICE_ID: '12003',
    OTYPE: 6,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取产品
export function queryProductFun1(data) {
  const params = {
    SERVICE_ID: '12003',
    OTYPE: 7,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取生产配置详情
export function productionDetailFun1(data) {
  const params = {
    SERVICE_ID: '12003',
    OTYPE: 3,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 添加生产详情
export function addDetailFun1(data) {
  const params = {
    SERVICE_ID: '12003',
    OTYPE: 5,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/productionSet.js